import { dayjsUtc, type Dayjs } from 'lib/dayjs'

export const padNum = (num: number): string => num?.toString()?.padStart(2, '0')

type DatePrefix = 'birth' | 'death' | 'spouseDeath' | 'will'

type DateValues =
  | 'birthYear'
  | 'birthMonth'
  | 'birthDay'
  | 'deathYear'
  | 'deathMonth'
  | 'deathDay'
  | 'spouseDeathYear'
  | 'spouseDeathMonth'
  | 'spouseDeathDay'
  | 'willYear'
  | 'willMonth'
  | 'willDay'

/** The date from a form's day, month and year fields. It's a date with no
 * time, so it's in UTC, which keeps it exact. */
export const getDateFromParts = ({
  prefix,
  values,
}: {
  prefix: DatePrefix
  values: { [dateValue in DateValues]?: string | number }
}): Dayjs | null => {
  const year = values[(prefix + 'Year') as DateValues]
  const month = values[(prefix + 'Month') as DateValues]
  const day = values[(prefix + 'Day') as DateValues]

  if (!year || !month || !day) return null
  if (year?.toString()?.length < 4) return null

  const date = dayjsUtc(
    `${year}-${padNum(Number(month))}-${padNum(Number(day))}`
  )
  return date.isValid() ? date : null
}
